/* eslint-disable @typescript-eslint/promise-function-async */
/* eslint-disable @typescript-eslint/await-thenable */
import classNames from 'classnames';
import React from 'react';
import { Link } from 'react-router-dom';
import { ITranslateProps, translate } from '../../mixins/translate';
import { IValidationState } from '../../mixins/validation';
import { fetchJson } from '../../store/fetch';
import { InspectionStandardTypes } from '../../utils/enums/InspectionStandardTypes';
import { IRouterProps } from '../../utils/IRouterProps';
import { isEemuaOrApi } from '../../utils/isEemuaOrApi';
import {
    Content,
    EditPanelCell,
    EditPanelInput,
    EditPanelRow,
    EditPanelSection,
    EditPanelSwitch,
    Panel,
    PanelBody,
    PanelButtonLink,
    PanelRouterLink,
    Table,
    Topbar,
    TopbarCrumb,
    TopbarCrumbActive,
    TopbarLeft,
    TopbarRight,
    Tray,
} from '../elements';
import { Spinner } from '../spinners';
import { DisplayMessage } from '../utils/displayMessage';
import { ElementRow, ICategory, IElement, IUnit } from './ElementRow';

interface IObjectTemplateEditState extends IValidationState {
    elements: IElement[];
    categories: ICategory[];
    name?: undefined | string;
    inspectionStandardId: string;
    inspectionStandardType: string;
    isEemuaOrApi: boolean;

    showElementForm: boolean;
    editElementId?: undefined | string;
    showUnitForm: boolean;
    editUnitId?: undefined | string;

    addElementNameRequiredError?: undefined | boolean;
    elementFormObjectTypeElementCode?: undefined | string;
    elementFormName?: undefined | string;
    elementFormCode?: undefined | string;
    elementFormIsDefault?: undefined | boolean;
    elementFormLocation?: undefined | string;
    elementFormReplacementIndex?: undefined | number;
    elementFormId?: undefined | string;
    elementCategoryId?: undefined | string;

    addUnitNameRequiredError?: undefined | boolean;
    unitFormObjectTypeUnitCode?: undefined | string;
    unitFormName?: undefined | string;
    unitFormCode?: undefined | string;
    unitFormIsDefault?: undefined | boolean;
    unitFormLocation?: undefined | string;
    unitFormReplacementIndex?: undefined | number;
    unitFormId?: undefined | string;
    unitFormElementId?: undefined | string;
}

interface IObjectTemplateEditProps extends ITranslateProps, IRouterProps {}

class ObjectTemplateEdit extends React.Component<IObjectTemplateEditProps, IObjectTemplateEditState> {
    constructor(props: IObjectTemplateEditProps) {
        super(props);

        this.state = {
            submitting: false,
            failed: false,
            saved: false,
            elements: [],
            categories: [],
            inspectionStandardId: this.props.match.params.id,
            inspectionStandardType: this.props.location.query.inspectiontype,
            isEemuaOrApi: isEemuaOrApi(this.props.location.query.inspectiontype),
            showElementForm: false,
            showUnitForm: false,
        };
    }

    public override async componentDidMount() {
        await this.loadElementsUnits();
        await this.loadCategories();
    }

    public override componentDidCatch(error: any) {
        this.setState({ submitting: false, failed: true, errorCode: error });
    }

    public override render() {
        return (
            <>
                <Topbar>
                    <TopbarLeft>
                        <TopbarCrumbActive title={this.props.t('common.composition')} icon="fa-cogs" />
                        <TopbarCrumb>
                            <Link to="/settings/objecttypes/">{this.props.t('common.objectTypes')}</Link>
                        </TopbarCrumb>
                    </TopbarLeft>
                    <TopbarRight>
                        {!this.state.isEemuaOrApi && !this.state.submitting && (
                            <>
                                <PanelRouterLink
                                    to={`/settings/objecttypes/inspectionstandards/${this.props.match.params.id}/import`}
                                    small={true}
                                    text={this.props.t('common.importItem', this.props.t('common.inspectionCompositionStandard'))}
                                    icon="fa fa-upload"
                                />
                                <PanelButtonLink
                                    onClick={() => this.handleAddElementClicked()}
                                    small={true}
                                    text={this.props.t('common.addItem', this.props.t('common.element'))}
                                    icon="fa fa-plus"
                                    mb0
                                />
                            </>
                        )}
                    </TopbarRight>
                </Topbar>

                <Content>
                    <Tray>
                        {this.renderMessage()}
                        <Panel>
                            {(this.state.submitting && <Spinner />) || (
                                <PanelBody noPadding={true}>
                                    <Table>
                                        {this.state.isEemuaOrApi &&
                                            this.state.categories.length > 0 &&
                                            this.state.categories.map((category, i) => [
                                                <>
                                                    <thead key={i}>
                                                        <tr className="active mt10">
                                                            <th colSpan={4} className="p10 fw600 fs16">
                                                                {category.name}{' '}
                                                            </th>
                                                        </tr>
                                                        <tr className="dark">
                                                            <th>{this.props.t('common.code')}</th>
                                                            <th>{this.props.t('common.part')}</th>
                                                            <th>&nbsp; </th>
                                                        </tr>
                                                    </thead>
                                                    {this.state.elements
                                                        .filter((element: any) => element.categoryId === category.id)
                                                        .map((element, j) => [
                                                            <ElementRow
                                                                isNen={false}
                                                                inspectionStandardId={this.state.inspectionStandardId}
                                                                key={j}
                                                                element={element}
                                                                submitting={this.state.submitting}
                                                                removeElement={this.removeElement.bind(this)}
                                                                removeUnit={this.removeUnit.bind(this)}
                                                                handleEditElementClicked={this.handleEditElementClicked.bind(this)}
                                                                handleAddUnitClicked={this.handleAddUnitClicked.bind(this)}
                                                                handleEditUnitClicked={this.handleEditUnitClicked.bind(this)}
                                                            />,
                                                        ])}
                                                    <tbody>
                                                        <tr>
                                                            <td colSpan={4} className="text-right mt10">
                                                                <button
                                                                    disabled={this.state.submitting}
                                                                    onClick={() => this.handleAddElementClicked(category.id)}
                                                                    className="btn btn-default btn-sm fw600 ml10 edit-element"
                                                                >
                                                                    <span className="fa fa-plus pr5"></span>{' '}
                                                                    {this.props.t('common.addItem', this.props.t('common.element'))}
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </>,
                                            ])}

                                        {!this.state.isEemuaOrApi && (
                                            <>
                                                <thead>
                                                    <tr className="dark">
                                                        <th>{this.props.t('common.code')}</th>
                                                        <th>{this.props.t('common.part')}</th>
                                                        <th>&nbsp; </th>
                                                    </tr>
                                                </thead>
                                                {this.state.elements.map((element, i) => [
                                                    <ElementRow
                                                        isNen={this.props.location.query.inspectiontype === InspectionStandardTypes.Nen2767}
                                                        inspectionStandardId={this.state.inspectionStandardId}
                                                        key={i}
                                                        element={element}
                                                        submitting={this.state.submitting}
                                                        removeElement={this.removeElement.bind(this)}
                                                        removeUnit={this.removeUnit.bind(this)}
                                                        handleEditElementClicked={this.handleEditElementClicked.bind(this)}
                                                        handleAddUnitClicked={this.handleAddUnitClicked.bind(this)}
                                                        handleEditUnitClicked={this.handleEditUnitClicked.bind(this)}
                                                    />,
                                                ])}
                                            </>
                                        )}
                                    </Table>
                                </PanelBody>
                            )}
                            <div id="popup_unit" className={classNames({ hidden: !this.state.showUnitForm })}>
                                <form method="post" action="/" id="admin-form">
                                    <div className="panel">
                                        <div className="panel-heading">
                                            <span className="panel-title">{this.props.t('common.addItem', this.props.t('common.unit'))}</span>
                                        </div>
                                        <div className="panel-body">
                                            <div className="my-slider">
                                                <EditPanelSection>
                                                    <EditPanelInput
                                                        name="unitFormName"
                                                        placeholder={this.props.t('object.customUnit')}
                                                        value={this.state.unitFormName}
                                                        icon="fa fa-pagelines"
                                                        handleChange={this.handleChange.bind(this)}
                                                        notValid={this.state.addUnitNameRequiredError}
                                                    />
                                                </EditPanelSection>
                                                <EditPanelRow>
                                                    <EditPanelCell rowCount={6}>
                                                        <EditPanelInput
                                                            name="unitFormLocation"
                                                            placeholder={this.props.t('common.location')}
                                                            value={this.state.unitFormLocation}
                                                            icon="fa fa-map-marker"
                                                            handleChange={this.handleChange.bind(this)}
                                                        />
                                                    </EditPanelCell>
                                                </EditPanelRow>
                                                <EditPanelRow>
                                                    <EditPanelCell rowCount={4}>
                                                        <EditPanelInput
                                                            name="unitFormCode"
                                                            placeholder={this.props.t('common.code')}
                                                            value={this.state.unitFormCode}
                                                            icon="fa fa-dashboard"
                                                            handleChange={this.handleChange.bind(this)}
                                                        />
                                                    </EditPanelCell>
                                                    {!this.state.isEemuaOrApi && (
                                                        <EditPanelCell rowCount={8}>
                                                            <EditPanelSwitch
                                                                name="unitFormIsDefault"
                                                                placeholder={this.props.t('object.unitIsDefault')}
                                                                value={this.state.unitFormIsDefault}
                                                                handleChange={this.handleChange.bind(this)}
                                                            />
                                                        </EditPanelCell>
                                                    )}
                                                </EditPanelRow>

                                                <div className=" text-right mt10">
                                                    <a
                                                        href="#"
                                                        onClick={(e) => this.handleCloseFormClicked(e)}
                                                        className="btn btn-sm fw600 ml10"
                                                        id="close"
                                                    >
                                                        {this.props.t('common.cancel')}
                                                    </a>

                                                    <button
                                                        disabled={this.state.submitting}
                                                        onClick={(e) => this.handleSaveUnit(e)}
                                                        className="btn btn-primary btn-sm fw600 ml10"
                                                        id="close-element-popup"
                                                    >
                                                        {this.props.t('common.saveItem', this.props.t('common.unit'))}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div id="popup_element" className={classNames({ hidden: !this.state.showElementForm })}>
                                <form method="post" action="/" id="admin-form" onSubmit={(e) => this.handleSaveElement(e)}>
                                    <div className="panel">
                                        <div className="panel-heading">
                                            <span className="panel-title">{this.props.t('common.addItem', this.props.t('common.element'))}</span>
                                        </div>
                                        <div className="panel-body">
                                            <div className="my-slider">
                                                <EditPanelSection>
                                                    <EditPanelInput
                                                        name="elementFormName"
                                                        placeholder={this.props.t('object.customElement')}
                                                        value={this.state.elementFormName}
                                                        icon="fa fa-pagelines"
                                                        handleChange={this.handleChange.bind(this)}
                                                        notValid={this.state.addElementNameRequiredError}
                                                    />
                                                </EditPanelSection>
                                                <EditPanelRow>
                                                    <EditPanelCell rowCount={6}>
                                                        <EditPanelInput
                                                            name="elementFormLocation"
                                                            placeholder={this.props.t('common.location')}
                                                            value={this.state.elementFormLocation}
                                                            icon="fa fa-map-marker"
                                                            handleChange={this.handleChange.bind(this)}
                                                        />
                                                    </EditPanelCell>
                                                </EditPanelRow>
                                                <EditPanelRow>
                                                    <EditPanelCell rowCount={4}>
                                                        <EditPanelInput
                                                            name="elementFormCode"
                                                            placeholder={this.props.t('common.code')}
                                                            value={this.state.elementFormCode}
                                                            icon="fa fa-dashboard"
                                                            handleChange={this.handleChange.bind(this)}
                                                        />
                                                    </EditPanelCell>
                                                    {!this.state.isEemuaOrApi && (
                                                        <EditPanelCell rowCount={8}>
                                                            <EditPanelSwitch
                                                                name="elementIsDefault"
                                                                placeholder={this.props.t('object.elementIsDefault')}
                                                                value={this.state.elementFormIsDefault}
                                                                handleChange={this.handleChange.bind(this)}
                                                            />
                                                        </EditPanelCell>
                                                    )}
                                                </EditPanelRow>

                                                <div className=" text-right mt10">
                                                    <a
                                                        href="#"
                                                        onClick={(e) => this.handleCloseFormClicked(e)}
                                                        className="btn btn-sm fw600 ml10"
                                                        id="close"
                                                    >
                                                        {this.props.t('common.cancel')}
                                                    </a>

                                                    <button
                                                        disabled={this.state.submitting}
                                                        onClick={(e) => this.handleSaveElement(e)}
                                                        className="btn btn-primary btn-sm fw600 ml10"
                                                        id="close-element-popup"
                                                    >
                                                        {this.props.t('common.saveItem', this.props.t('common.element'))}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>{' '}
                            {/* End popup_element */}
                            <div
                                id="background_popup"
                                className={classNames({ hidden: !this.state.showElementForm && !this.state.showUnitForm })}
                                style={{ opacity: 0.6, display: 'block' }}
                                onClick={(e) => this.handleCloseFormClicked(e)}
                            ></div>
                        </Panel>
                    </Tray>
                </Content>
            </>
        );
    }
    private handleChange(value: any, stateKey: string) {
        const newState = {} as any;
        newState[stateKey] = value;

        this.setState(newState);
    }

    private async handleSaveElement(e: any) {
        e.preventDefault();

        const element = {
            name: this.state.elementFormName,
            location: this.state.elementFormLocation,
            code: this.state.elementFormCode,
            isDefault: this.state.elementFormIsDefault,
            categoryId: this.state.elementCategoryId,
            inspectionStandardId: this.state.inspectionStandardId,
        } as any;
        if (!element.name || element.name === '') {
            this.setState({ addElementNameRequiredError: true });
        } else {
            let url = '/api/objectTypeElements';
            if (this.state.elementFormId) {
                url += `/${this.state.elementFormId}`;
            }
            await this.setState({ addElementNameRequiredError: false, submitting: true });
            const result = await fetchJson(url, 'POST', element);
            if (result.successful) {
                await this.setState({ submitting: false, failed: false, showElementForm: false, showUnitForm: false });
                await this.loadElementsUnits();
            } else {
                await this.setState({ submitting: false, failed: true, errorCode: result.errorCode });
            }
        }
    }

    private handleAddElementClicked(categoryid?: string) {
        this.setState({
            showElementForm: true,
            elementFormObjectTypeElementCode: '',
            elementFormCode: undefined,
            elementFormLocation: undefined,
            elementFormName: undefined,
            elementFormId: undefined,
            elementFormReplacementIndex: 1,
            elementFormIsDefault: this.state.isEemuaOrApi,
            elementCategoryId: categoryid,
        });
    }

    private handleEditElementClicked(elementId: string) {
        for (let i = 0; i < this.state.elements.length; i++) {
            const element = this.state.elements[i]!;
            if (element.id === elementId) {
                this.setState({
                    showElementForm: true,
                    elementFormObjectTypeElementCode: '',
                    elementFormCode: element.code,
                    elementFormLocation: element.location,
                    elementFormName: element.name,
                    elementFormId: element.id,
                    elementFormIsDefault: element.isDefault,
                    elementCategoryId: element.categoryId,
                });
                break;
            }
        }
    }

    private async handleSaveUnit(e: any) {
        e.preventDefault();

        const unit = {
            location: this.state.unitFormLocation,
            objectTypeElementId: this.state.unitFormElementId,
            name: this.state.unitFormName,
            code: this.state.unitFormCode,
            isDefault: this.state.unitFormIsDefault,
        } as any;

        if (!unit.name || unit.name === '') {
            await this.setState({ addUnitNameRequiredError: true });
        } else {
            let url = '/api/objectTypeUnits';
            if (this.state.unitFormId) {
                url += `/${this.state.unitFormId}`;
            }
            await this.setState({ addUnitNameRequiredError: false, submitting: true });
            const result = await fetchJson(url, 'POST', unit);
            if (result.successful) {
                await this.setState({ submitting: false, failed: false, showElementForm: false, showUnitForm: false });
                await this.loadElementsUnits();
            } else {
                await this.setState({ submitting: false, failed: true, errorCode: result.errorCode });
            }
        }
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    private handleAddUnitClicked(elementId: string) {
        this.setState({ showUnitForm: true });
        this.setState({
            showUnitForm: true,
            unitFormObjectTypeUnitCode: '',
            unitFormCode: undefined,
            unitFormLocation: undefined,
            unitFormReplacementIndex: 1,
            unitFormName: undefined,
            unitFormId: undefined,
            unitFormIsDefault: this.state.isEemuaOrApi,
            unitFormElementId: elementId,
        });
    }

    private getElementFromState(elementId: string) {
        for (let i = 0; i < this.state.elements.length; i++) {
            const element = this.state.elements[i]!;
            if (element.id === elementId) {
                return element;
            }
        }
        return undefined;
    }

    private getUnitFromState(elementId: string, unitId: string) {
        const element = this.getElementFromState(elementId) as any;

        for (let i = 0; i < element.units.length; i++) {
            const unit = element.units[i];
            if (unit.id === unitId) {
                return unit;
            }
        }
        return undefined;
    }

    private handleEditUnitClicked(elementId: string, unitId: string) {
        const unit = this.getUnitFromState(elementId, unitId);
        this.setState({
            showUnitForm: true,
            unitFormObjectTypeUnitCode: '',
            unitFormCode: unit.code,
            unitFormLocation: unit.location,
            unitFormIsDefault: unit.isDefault,
            unitFormName: unit.name,
            unitFormId: unit.id,
        });
    }

    private handleCloseFormClicked(e: any) {
        e.preventDefault();
        this.setState({ showElementForm: false, showUnitForm: false });
    }

    private async loadElementsUnits() {
        const url = `/api/inspectionStandards/${this.props.match.params.id}/elements`;
        await this.setState({ submitting: true });
        const result = await fetchJson(url, 'GET');
        if (result.successful) {
            await this.setState({ elements: result.json, submitting: false });
        } else {
            await this.setState({ submitting: false, failed: true, errorCode: result.errorCode });
        }
    }

    private async loadCategories() {
        const url = `/api/inspectionStandards/${this.props.match.params.id}/categories`;
        await this.setState({ submitting: true });
        const result = await fetchJson(url, 'GET');
        if (result.successful) {
            await this.setState({ categories: result.json, submitting: false });
        } else {
            await this.setState({ submitting: false, failed: true, errorCode: result.errorCode });
        }
    }

    private async removeElement(element: IElement) {
        await this.remove(`/api/objectTypeElements/${element.id}`);
        if (!this.state.failed) {
            await this.loadElementsUnits();
        }
    }

    private async removeUnit(unit: IUnit) {
        await this.remove(`/api/objectTypeUnits/${unit.id}`);
        if (!this.state.failed) {
            await this.loadElementsUnits();
        }
    }

    private async remove(url: string) {
        await this.setState({ submitting: true });
        const result = await fetchJson(url, 'DELETE');
        if (result.successful) {
            await this.setState({ submitting: false, failed: false });
        } else {
            await this.setState({ submitting: false, failed: true, errorCode: result.errorCode });
        }
    }

    private renderMessage() {
        if (this.state.failed) {
            const message = `${this.props.t('validation.general')} Code: ${this.state.errorCode}`;
            return <DisplayMessage message={message} messageType="error" />;
        }
        return null;
    }
}

// eslint-disable-next-line import/no-default-export
export default translate()(ObjectTemplateEdit);
